import { getDealWithActiveMips } from '@dealstack/frontend/shared/dataExchange/services/god.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

export const useManageDeal = () => {
	const { dealId } = useParams();

	const getDealRequest = useQuery({
		queryKey: [formatUnicorn(API_PATHS.GODMODE_DEAL_DEALID_GET, { dealId: dealId || '' })],
		queryFn: ({ signal }) =>
			getDealWithActiveMips(
				formatUnicorn(API_PATHS.GODMODE_DEAL_DEALID_GET, { dealId: dealId || '' }),
				signal
			),
	});

	const refetchMipData = useCallback(() => {
		// oxlint-disable-next-line typescript/no-floating-promises
		getDealRequest.refetch();
	}, [getDealRequest?.data?.payload]);

	return {
		isLoading: getDealRequest?.isLoading,
		dealData: getDealRequest?.data?.payload,
		dealId,
		refetchMipData,
	};
};
